import ConciergeCurbsidePickupIndicator from 'components/ConciergeCurbsidePickupIndicator/ConciergeCurbsidePickupIndicator';

export default ConciergeCurbsidePickupIndicator;
